import * as React from 'react';
import { Radio as AntRadio } from 'antd';
import { RadioProps as AntRadioProps } from 'antd/lib/radio';

export type RadioProps = {
  children?: React.ReactNode;
  autoFocus: boolean;
  checked: boolean;
  defaultChecked: boolean;
  disabled: boolean;
  value?: any;
};

const Radio = (props: RadioProps & AntRadioProps) => {
  return <AntRadio {...props} className="radio" />;
};

Radio.defaultProps = {
  autoFocus: false,
  checked: false,
  defaultChecked: false,
  disabled: false,
};

export default Radio;
